import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/** Paginator tabel po polsku (Issue 6 p. 8: „Items per page”, „1 – 2 of 2”). */
@Injectable()
export class PlPaginatorIntl extends MatPaginatorIntl {
    override itemsPerPageLabel = 'Na stronie';
    override nextPageLabel = 'Następna strona';
    override previousPageLabel = 'Poprzednia strona';
    override firstPageLabel = 'Pierwsza strona';
    override lastPageLabel = 'Ostatnia strona';

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 z ${length}`;
        }

        const start = page * pageSize;
        const end = Math.min(start + pageSize, length);

        return `${start + 1}–${end} z ${length}`;
    };
}
